module.exports = function (area) {
    return {
        event: 'BWSAUmyAccountAuthenticate',
        eventContext: {
            area
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/authenticate-analytics-mapper.js
 **/